module.exports = __webpack_public_path__ + "static/media/add-user-img.7fd717d0.svg";